import { render, staticRenderFns } from "./PostLedgerPage.vue?vue&type=template&id=426165b0&"
import script from "./PostLedgerPage.vue?vue&type=script&lang=js&"
export * from "./PostLedgerPage.vue?vue&type=script&lang=js&"
import style0 from "./PostLedgerPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports